// assets/promo-messages.js
function refreshPromoMessages () {
  const url = `${window.Shopify.routes.root}?sections=cart-messaging`;   // <─ Section Rendering API
  fetch(url)
    .then(r => r.json())
    .then(html => {
      // html['cart-messaging'] contiene la sección renderizada
      const container = document.getElementById('promo-messages');
      if (container && html['cart-messaging']) {
        container.outerHTML = html['cart-messaging'];
      }
    })
    .catch(console.error);
}

// Dawn ≥ 8 dispara este evento cada vez que el carrito cambia
document.addEventListener('cart:updated', refreshPromoMessages);

// Para temas que emiten otro —p.ej. ajaxProduct:added en Be Yours, product:added en algunos Premium—
// duplica la línea:
document.addEventListener('ajaxProduct:added', refreshPromoMessages);